import Vue from 'vue';
import store from '../store';
import events from '../../events/events';

const state =
{
    ready: false,
    modules: [],
    updated: null,
    loaded: null,
    env: 'production',
    touchDevice: false,
    os: null,
    mouseDown: false,
    university: false,
    maintenance: false,
    baseUrl: '',
};

const actions =
{
    init ({dispatch, commit}, callback)
    {
        Vue.http.get('/api/app/init')
        .then(response =>
        {
            commit('current/INIT', response.data, { root: true });
            commit('INIT', response.data);
            commit('SET_READY', true);

            events.$emit('app.authenticated');

            if ( ! store.state.layout.viewport) dispatch('layout/setViewport', null, { root: true });

            if (callback) callback();
        })
        .catch(error =>
        {
            // server is in maintenance mode
            if (error.response && error.response.status == 503 || error.response.status == 504)
            {
                commit('MAINTENANCE', true);
                commit('SET_READY', true);
                return;
            }

            // something went wrong... log user out
            dispatch('auth/logout', () => {
                window.location.href = Vue.onduro.route('login.signin');
            }, { root: true });
        });
    },

    reinit ({dispatch, commit}, callback)
    {
        // don't show loader on re-init

        Vue.http.get('/api/app/init')
        .then(response =>
        {
            commit('current/INIT', response.data, { root: true });
            commit('REINIT', response.data);

            if (callback) callback();
        })
        .catch(error =>
        {
            // server is in maintenance mode
            if (error.response.status == 503 || error.response.status == 504)
            {
                commit('MAINTENANCE', true);
                commit('SET_READY', true);
                return;
            }

            // something went wrong... log user out
            dispatch('auth/logout', () => {
                window.location.href = Vue.onduro.route('login.signin');
            }, { root: true });
        });
    },

    mouseDown ({dispatch, commit}, status)
    {
        commit('MOUSE_DOWN', status);
    },

    loader ({dispatch, commit}, show)
    {
        commit('LOADER', show);
    },

    maintenance ({dispatch, commit}, status)
    {
        commit('MAINTENANCE', status);
    },
};

const mutations =
{
    INIT (state, data)
    {
        state.modules = data.app.modules;
        state.updated = data.app.updated;
        state.loaded = data.app.loaded;

        let user = store.state.current.user;
        let account = store.state.current.account;
        let services = data.app.services;

        if (location.hostname.match('localhost') || location.hostname.match('.onduro.test'))
        {
            state.env = 'local';
            state.baseUrl = 'http://localhost';
        }
        else if (location.hostname.match('mobile'))
        {
            state.env = 'mobile';
            state.touchDevice = true;
            state.baseUrl = 'https://mobile.onduro.com';
        }
        else if (location.hostname.match('alpha'))
        {
            state.env = 'alpha';
            state.baseUrl = 'https://alpha.onduro.com';
        }
        else if (location.hostname.match('beta'))
        {
            state.env = 'beta';
            state.baseUrl = 'https://beta.onduro.com';
        }
        else if (location.hostname.match('test'))
        {
            state.env = 'test';
            state.baseUrl = 'https://test.onduro.com';
        }

        let userAgent = window.navigator.userAgent.toLowerCase();

        if (/android/i.test(userAgent)) {
            state.touchDevice = true;
            state.os = 'android';
        }

        if (/ipad|iphone|ipod/i.test(userAgent)) {
            state.touchDevice = true;
            state.os = 'ios';
        }

        if (services.intercom && ! store.state.auth.fake)
        {
            window.intercomSettings =
            {
                app_id: services.intercom,
                user_id: user.intercom,
                name: user.name,
                email: user.email,
                custom_launcher_selector: ".box-intercom",
                created_at: user.createdAt,
                user_hash: user.intercomHmac,
                language_override: Vue.config.lang,
                company: {
                    id: account.intercom,
                    name: account.name,
                    demo: account.demo,
                    demo_activated: 'true',
                    beta: account.beta ? 'true' : 'false',
                    created_at: account.createdAt,
                    plan: account.status,
                    modules: account.modules.join('|'),
                    country: account.settings.country,
                    dpa: account.agreements.dpa,
                },
                biller: Vue.onduro.hasRole('biller') ? 'true' : 'false',
                accountant: Vue.onduro.hasRole('accountant') ? 'true' : 'false',
                supervisor: Vue.onduro.hasRole('supervisor') ? 'true' : 'false',
                role_owner: Vue.onduro.hasRole('owner') ? 'true' : 'false',
                role_manager: Vue.onduro.hasRole(['owner', 'manager']) ? 'true' : 'false',
                role_planner: Vue.onduro.hasRole('planner') ? 'true' : 'false',
                language: Vue.config.lang,
            };

            (function()
            {
                var w=window;
                var ic=w.Intercom;
                if (typeof ic==="function")
                {
                    ic('reattach_activator');
                    ic('update',intercomSettings);
                }
                else
                {
                    var d=document;
                    var i=function()
                    {
                        i.c(arguments)
                    };
                    i.q=[];
                    i.c=function(args){i.q.push(args)};
                    w.Intercom=i;

                    // launch intercom
                    var s=d.createElement('script');
                        s.type='text/javascript';
                        s.async=true;
                        s.src='//widget.intercom.io/widget/' + services.intercom;

                    var x=d.getElementsByTagName('script')[0];
                        x.parentNode.insertBefore(s,x);
                }
            })();
        }
        else
        {
            // unload intercom
            window.Intercom = null;
        }
    },

    REINIT (state, data)
    {
        state.modules = data.app.modules;
        state.updated = data.app.updated;
        state.loaded = data.app.loaded;
    },

    SET_READY (state, ready)
    {
        state.ready = ready;
    },

    MOUSE_DOWN (state, status)
    {
        state.mouseDown = status;
    },

    MAINTENANCE (state, status)
    {
        state.maintenance = status;
    },
};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/app.js